/* ── Streak helpers ──────────────────────────────────────────────
   Shared by the dashboard "This week" card and the header streak
   pill so the two can never disagree about whether today counts. */

const DAY_MS = 86400000;

function startOfDay(value) {
  const d = new Date(value);
  d.setHours(0, 0, 0, 0);
  return d;
}

/* Did the user already study today? */
export function isStudiedToday(lastStudied) {
  if (!lastStudied) return false;
  return startOfDay(lastStudied).getTime() === startOfDay(new Date()).getTime();
}

/* A streak survives until the end of the day after the last study day —
   so "yesterday" still counts as alive, anything older is broken. */
export function isStreakAlive(lastStudied) {
  if (!lastStudied) return false;
  const days = Math.round((startOfDay(new Date()) - startOfDay(lastStudied)) / DAY_MS);
  return days <= 1;
}

/* A streak is by definition a run of consecutive days ending at lastStudied,
   which lets us rebuild the last 7 days without a per-day activity log. */
export function buildWeekStreak(streak, lastStudied) {
  const dayLabels = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
  const today = startOfDay(new Date());
  const anchor = lastStudied ? startOfDay(lastStudied) : null;
  const alive = isStreakAlive(lastStudied);

  const activeDates = new Set();
  if (alive && streak > 0) {
    for (let i = 0; i < streak; i++) {
      const d = new Date(anchor);
      d.setDate(d.getDate() - i);
      activeDates.add(d.toDateString());
    }
  }

  const cells = [];
  for (let i = 6; i >= 0; i--) {
    const d = new Date(today);
    d.setDate(d.getDate() - i);
    cells.push({
      label: dayLabels[d.getDay()],
      active: activeDates.has(d.toDateString()),
      isToday: i === 0,
    });
  }
  return cells;
}
